<ul class="nav nav-secondary mixed-loyalty-nav mt-0 mb-3">
  <a
    class="nav-item btn"
    [routerLink]="['/managetickets/']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label> Top Up Ticket </label>
  </a>
  <a
    class="nav-item btn"
    [routerLink]="['/manageticketshistory']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label class="nav-link">History</label>
  </a>
</ul>
